import { Controller } from "@hotwired/stimulus";

export default class extends Controller<HTMLElement> {
    static values = {
        url: String,
    };

    declare readonly urlValue: string;
    declare readonly hasUrlValue: boolean;

    private details: HTMLDetailsElement | null = null;
    private loading = false;

    connect(): void {
        this.loadWhenOpen = this.loadWhenOpen.bind(this);
        this.details = this.element.closest("details");
        this.details?.addEventListener("toggle", this.loadWhenOpen);
        this.loadWhenOpen();
    }

    disconnect(): void {
        this.details?.removeEventListener("toggle", this.loadWhenOpen);
        this.details = null;
    }

    private loadWhenOpen(): void {
        if (!this.details?.open || this.loading || !this.hasUrlValue) {
            return;
        }

        const ajax = window.htmx?.ajax;
        if (!ajax) {
            return;
        }

        this.loading = true;
        const finish = (): void => { this.loading = false; };
        // HTMX reports network/HTTP failures through its events. Release the guard
        // on either outcome so reopening the section can retry a failed request.
        void Promise.resolve(ajax("GET", this.urlValue, {
            source: this.element,
            target: this.element,
            swap: "outerHTML",
        })).then(finish, finish);
    }
}
